export default {
  today: 'Today',
};
